import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import { Icon } from '@mui/material'
import AdxTableBottomCTA from 'components/reusable/table/AdxTableBottomCTA'
import UnsubmittedReportsList from './lists/UnsubmittedReportsList'
import { getQueryReports } from 'services/api/modules/claim/report'
import { ReportIconConstructor } from 'module/claim/pages/report/functions'
import EmptyData from 'module/leave/pages/createRequest/components/emptyData'
import reportStatusConverter from 'module/claim/services/helper/reportStatusConverter'
import ClaimLoadingState from './ClaimLoadingState'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

const CompletedReportPanel = () => {
  const ViewAllUnsubmittedButton = () => {
    const navigate = useNavigate()
    return (
      <Typography
        variant="body1"
        color="alternate.main"
        sx={{ textDecoration: 'underline', cursor: 'pointer' }}
        onClick={() =>
          navigate(`../claim/reports`, {
            state: { fromDashboard: true, initialTabsValue: 3 },
          })
        }
      >
        View All
      </Typography>
    )
  }

  // API CALL
  const { data: reimbursedData, isLoading: reimbursedIsLoading } = useQuery(
    'CompletedReportsData',
    async () => {
      const { data } = await getQueryReports({
        status: 'reimbursement complete',
      })
      return data?.reports
    }
  )

  const { data: rejectedData, isLoading: rejectedIsLoading } = useQuery(
    'RejectedReportsData',
    async () => {
      const { data } = await getQueryReports({
        status: 'rejected',
      })
      return data?.reports
    }
  )

  const isLoading = reimbursedIsLoading || rejectedIsLoading

  // data concatenation for report status complete reimbursemnet and rejected
  const [data, setData] = useState([])

  useEffect(() => {
    if (reimbursedData && rejectedData) {
      setData([...reimbursedData, ...rejectedData].sort((a, b) => a.id - b.id))
    }
  }, [reimbursedData, rejectedData])

  if (isLoading) {
    return <ClaimLoadingState />
  }

  return (
    <AdxTableBottomCTA
      bottomCTA={<ViewAllUnsubmittedButton />}
      // emptyStateComponent={isLoading && loadingComponent}
      emptyStateComponent={
        <AdxEmptyStateV2 icon={<Icon>article</Icon>} title="No approved reports" />
      }
    >
      {data?.length > 0 &&
        data?.slice(0, 7)?.map((list, index) => (
          <UnsubmittedReportsList
            key={index}
            reportID={list.id}
            reportType={list.claim_report_type}
            reportName={list.title}
            muiIcon={ReportIconConstructor(list.claim_report_type)}
            startDate={list.start_date}
            endDate={list.end_date}
            totalAmount={list.amount_total}
            // numberExpenses={list.expenses.length}
            status={reportStatusConverter(list.report_status.name)}
          />
        ))}
    </AdxTableBottomCTA>
  )
}

export default CompletedReportPanel
